// extracted by mini-css-extract-plugin
export default {"main":"SectionHeader_main__SMiN4","title":"SectionHeader_title__bu9pF"};